import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../data/images';
import { ButtonLink } from '../ui/ButtonLink';
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.06
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 14
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }
  }
};
const focusAreas = ['Executive & C-Suite Search', 'Board & Non-Executive Directors', 'Confidential Assignments'];
export function HomeHero() {
  return <section className="on-dark relative overflow-hidden bg-aubergine text-porcelain" data-id="element-211" data-mp="31s6itc22vr6x">
      <div className="mx-auto grid max-w-7xl items-center gap-6 px-6 pt-32 lg:grid-cols-12 lg:gap-10 lg:px-10 lg:pt-36" data-id="element-212" data-mp="2n4trt7ti4t95">
        <motion.div className="relative z-10 lg:col-span-6" variants={container} initial="hidden" animate="show" data-id="element-213" data-mp="2s23rrheionb8">
          <motion.p variants={item} className="font-serif text-xl italic text-copper-light" data-id="element-214" data-mp="3frei04y8qzb4">
            Strategic Search. Meaningful Connections. Lasting Impact.
          </motion.p>
          <motion.h1 variants={item} className="mt-6 text-[2.75rem] font-semibold leading-[1.04] tracking-tight sm:text-6xl xl:text-[4.5rem]" data-id="element-215" data-mp="ow0l6ax87tez">
            Exceptional Leaders.{' '}
            <span className="font-serif font-medium italic text-copper-light" data-id="element-216" data-mp="xou3yibvtaxl">Extraordinary</span> Possibilities.
          </motion.h1>
          <motion.p variants={item} className="mt-8 max-w-xl text-lg leading-relaxed text-porcelain/75" data-id="element-217" data-mp="17lqe0shfi549">
            Aurevane Search Partners connects ambitious organizations with exceptional leadership talent. Through a thoughtful, relationship-driven approach to executive search, we help organizations identify the people who will shape their next chapter of growth.
          </motion.p>
          <motion.div variants={item} className="mt-10 flex flex-wrap gap-4" data-id="element-218" data-mp="1ciyvsryo074z">
            <ButtonLink to="/employers#inquiry" size="lg" data-id="element-219" data-mp="3ie1ldve6scgs">
              Discuss Your Hiring Needs
            </ButtonLink>
            <ButtonLink to="/expertise" variant="outline-light" size="lg" data-id="element-220" data-mp="1hbk19edixuw9">
              Explore Our Expertise
            </ButtonLink>
          </motion.div>
        </motion.div>
        <motion.div className="relative pb-12 lg:col-span-5 lg:col-start-8 lg:pb-16" initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1],
        delay: 0.1
      }} data-id="element-221" data-mp="1mcpv5fix7o7d">
          <span aria-hidden="true" className="absolute -right-3 top-6 bottom-6 hidden w-full rounded-2xl border border-copper-light/40 lg:block" data-id="element-222" data-mp="209v9e2ssftdp" />
          <img src={images.heroExecutive} alt="A senior executive in a tailored charcoal suit standing in a modern office overlooking the city" className="relative aspect-[4/5] max-h-[620px] w-full rounded-2xl object-cover object-top" data-id="element-223" data-mp="2a07ubw4ilokd" />
        </motion.div>
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-224" data-mp="2nzh8kq95u8lp">
        <ul className="grid border-t border-porcelain/10 sm:grid-cols-3" data-id="element-225" data-mp="2nxwcuxb40jm9">
          {focusAreas.map((area, i) => <li key={area} className={`py-6 text-sm font-medium text-porcelain/70 sm:py-8 ${i > 0 ? 'border-t border-porcelain/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-226" data-mp="8b1vmvmvq4fd" data-mpi={i}>
              {area}
            </li>)}
        </ul>
      </div>
    </section>;
}